<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-reference`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.05 26a1 1 0 011 1v2a1 1 0 01-1 1H16c-3.73 0-6.86 2.55-7.75 6A8.226 8.226 0 008 38v2h16.05a1 1 0 011 1v2a1 1 0 01-1 1H6c-1.1 0-2-.895-2-2v-4c0-6.627 5.37-12 12-12h8.05zm12.728-.707l7.071 7.071a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-2.937-2.937v10.33a1 1 0 01-1 1h-2a1 1 0 01-1-1V32.229l-2.963 2.964a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l7.071-7.071a1 1 0 011.414 0zM21 3c5.52 0 10 4.477 10 10s-4.48 10-10 10-10-4.477-10-10S15.48 3 21 3zm0 4c-3.31 0-6 2.686-6 6s2.69 6 6 6 6-2.686 6-6-2.69-6-6-6z"/></svg>
</template>
<script>

export default {
  name: 'IconReference',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
